import { MKPlayerError } from "./MKPlayerError";
import { MKConstants, MKCustomError } from "../../constants";

/**
 * Bitmovin player wrapper error object.
 * @internal
 */
export class MKBitmovinPlayerError extends MKPlayerError {
    constructor(errorObj: any) {
        super();
        if ("code" in errorObj) {
            this.code = this.getErrorCode(errorObj.code);
        } else {
            this.code = MKConstants.ErrorCodeTemplate.PlayerError.replace("{submodule}", "0").replace("{code}", MKCustomError.Unknown.code);
        }
        this.message = errorObj.message ?? MKCustomError.Unknown.message;
    }

    private getErrorCode(code: number): string {
        // template: "4-7{submodule}-{code}"
        const errorCodeTemplate = MKConstants.ErrorCodeTemplate.PlayerError;
        if (code >= 1000 && code < 1200) {
            // GENERAL & SETUP related errors -> 4-70-{code}
            return errorCodeTemplate.replace("{submodule}", "0").replace("{code}", code.toString());
        } else if (code >= 1200 && code < 1300) {
            // SOURCE errors -> 4-71-{code}
            return errorCodeTemplate.replace("{submodule}", "1").replace("{code}", code.toString());
        } else if (code >= 1300 && code < 1400) {
            // PLAYBACK errors -> 4-72-{code}
            return errorCodeTemplate.replace("{submodule}", "2").replace("{code}", code.toString());
        } else if (code >= 1400 && code < 1500) {
            // NETWORK errors -> 4-73-{code}
            return errorCodeTemplate.replace("{submodule}", "3").replace("{code}", code.toString());
        } else if (code >= 2000 && code < 2100) {
            // DRM errors -> 4-74-{code}
            return errorCodeTemplate.replace("{submodule}", "4").replace("{code}", code.toString());
        } else if (code >= 2100 && code < 2200) {
            // VR errors -> 4-75-{code}
            return errorCodeTemplate.replace("{submodule}", "5").replace("{code}", code.toString());
        } else if (code >= 3000 && code < 3100) {
            // Modules errors -> 4-76-{code}
            return errorCodeTemplate.replace("{submodule}", "6").replace("{code}", code.toString());
        }  else if (code >= 3100 && code < 3200) {
            // Modules advertising errors -> 4-77-{code}
            return errorCodeTemplate.replace("{submodule}", "7").replace("{code}", code.toString());
        }
        return errorCodeTemplate.replace("{submodule}", "0").replace("{code}", MKCustomError.Unknown.code);
    }
}